import { FormattedMessage } from 'react-intl';
import Button from '../../atoms/Button';
import MainHeadline from '../../atoms/MainHeadline';
import './style.scss';

const PromotionEngineError = ({ onClose, onSubmit }: { onClose: () => void; onSubmit: () => void }) => (
  <div className="promotion-engine-error">
    <div className="promotion-engine-error__headline">
      <MainHeadline>
        <FormattedMessage id="payment.promotionEngineError.headline" />
      </MainHeadline>
    </div>
    <div className="promotion-engine-error__text">
      <FormattedMessage id="payment.promotionEngineError.text" />
    </div>
    <div className="promotion-engine-error__action-buttons">
      <Button
        type="button"
        className="promotion-engine-error__action-buttons__back"
        onClick={onClose}
        data-test-id="promotion-engine-error-back"
      >
        <FormattedMessage id="payment.promotionEngineError.buttons.back" />
      </Button>
      <Button type="button" onClick={onSubmit} data-test-id="promotion-engine-error-submit">
        <FormattedMessage id="payment.promotionEngineError.buttons.submit" />
      </Button>
    </div>
  </div>
);

export default PromotionEngineError;
